import { FaFacebook, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';
import './SocialAnimate.css';

const SocialAnimate = () => {
  return (
      <div className="social-animate">
          <ul>
              <li>
                  <a
                      href="https://facebook.com/multibrandprint"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook profile"
                  >
                      <FaFacebook className="fab" />
                  </a>
              </li>

              <li>
                  <a
                      href="https://instagram.com/multibrandprints"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram profile"
                  >
                      <FaInstagram className="fab" />
                  </a>
              </li>

              <li>
                  <a
                      href="https://twitter.com/oguntoyintaiwo"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter / X profile"
                  >
                      <FaX className="fab" />
                  </a>
              </li>

              <li>
                  <a
                      href="https://www.linkedin.com/in/taiwo-oguntoyinbo-kolawole"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn profile"
                  >
                      <FaLinkedin className="fab" />
                  </a>
              </li>

              <li>
                  <a
                      href="https://github.com/taiwosugar1"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="GitHub profile"
                  >
                      <FaGithub className="fab" />
                  </a>
              </li>
          </ul>
    </div>
    );
};

export default SocialAnimate;
